/* eslint-disable no-console */
import { Box } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { CalculationSourceConfigEditor } from './CalculationSourceConfigEditor';
import { PropertyKeyEditor } from './PropertyKeyEditor';
import { ValueConfigEditor } from './ValueConfigEditor';

// custom UI for concentration limit config
export const ConcentrationConfigVisualEditor = ({
  value,
  onChange,
  availableFields,
}: {
  value: CreditAgreement.Config.ConcentrationLimit.SourceConfig;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.SourceConfig,
  ) => void;
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
}) => {
  const [
    currentSourceConfig,
    setCurrentSourceConfig,
  ] = React.useState<CreditAgreement.Config.ConcentrationLimit.SourceConfig>(
    value,
  );

  // const [isConfgValid, setIsConfigValid] = React.useState<boolean>(true);

  React.useEffect(() => {
    setCurrentSourceConfig(value);
  }, [value]);

  const updateConfig = (
    newValue: CreditAgreement.Config.ConcentrationLimit.SourceConfig,
  ) => {
    setCurrentSourceConfig(newValue);
    onChange(newValue);
  };

  if (!currentSourceConfig.calculationConfig) {
    console.log('missing calculation config: ', value);
    return null;
  }

  if (!currentSourceConfig.valueConfig) {
    console.log('missing value config: ', value);
    return null;
  }

  // we guard against currentSourceConfig.calculationConfig.type being invalid
  // because this UI gets re-rendered as JSON gets edited, and that means
  // we need to handle interim invalid values.
  if (
    !CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfigIterable.includes(
      currentSourceConfig.calculationConfig.type,
    )
  ) {
    return null;
  }

  return (
    <Box p={2}>
      {/* propertyKey */}
      <PropertyKeyEditor
        value={currentSourceConfig.propertyKey}
        onChange={(newValue) => {
          updateConfig({
            ...value,
            propertyKey: newValue,
          });
        }}
      />

      {/* calculationConfig */}
      <CalculationSourceConfigEditor
        value={currentSourceConfig.calculationConfig}
        availableFields={availableFields}
        onChange={(newValue) => {
          updateConfig({
            ...value,
            calculationConfig: newValue,
          });
        }}
      />

      {/* valueConfig */}
      <ValueConfigEditor
        value={currentSourceConfig.valueConfig}
        onChange={(newValue) => {
          updateConfig({
            ...value,
            valueConfig: newValue,
          });
        }}
      />
    </Box>
  );
};
